// eslint-disable-next-line import/no-cycle
import { httpMgr } from '../../common/network/httpMgr';
import { ApiEnums } from '../../constants/apiConstants';

export function getCityList() {
  return httpMgr.request(ApiEnums.GET_CITY_LIST);
}

export default {};
